import * as yup from "yup"
import moment from "moment"
export const promoSchema = yup.object().shape({
    code: yup
        .string()
        .required("Promo code is required")
        .trim()
        .matches(/^\S*$/, "No spaces allowed in promo code"),
    expirationDate: yup.string()
        .required('expiration date is required')
        .test('future-date', 'expiration date must be in the future', (value) => {
            if (!value) return true
            return moment(value).startOf('day').isSameOrAfter(moment().startOf('day'))
        }),
    redeemLimit: yup.number()
        .typeError('Must be a number')
        .integer('Must be an integer')
        .min(0, 'Cannot be negative')
        .required('Redeem limit is required'),

    isActive: yup.boolean(),
})
